/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Progress_BestInputs */

const en_features_progress_best = /** @type {(inputs: Features_Progress_BestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Best set, 8 weeks`)
};

const pl_features_progress_best = /** @type {(inputs: Features_Progress_BestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najlepsza seria, 8 tygodni`)
};

/**
* | output |
* | --- |
* | "Best set, 8 weeks" |
*
* @param {Features_Progress_BestInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_progress_best = /** @type {((inputs?: Features_Progress_BestInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Progress_BestInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_progress_best(inputs)
	return en_features_progress_best(inputs)
});